import { IStaticAction } from '../actions/staticAsyncAction';
import { STATIC_STATE, IStaticState } from '../states/staticStates';

const staticStateReducer = (state: IStaticState = STATIC_STATE, action: IStaticAction) => {
    switch (action.type) {
        case 'RENDER_COMPLETE_FINSUM':
            return { ...state, staticFinSumRenderComplete: action.value };
        case 'RENDER_COMPLETE_CW':
            return { ...state, staticCWRenderComplete: action.value };
        case 'REQUEST_STATIC_FINSUM_DATA':
            return { ...state };
        case 'RECEIVE_STATIC_FINSUM_DATA':
            return {
                ...state, staticFinSumData: {
                    ...state.staticFinSumData,
                    [action.index]: action.value
                }
            };
        case 'REQUEST_THEMES_DATA':
            return { ...state };
        case 'RECEIVE_THEMES_DATA':
            return {
                ...state, staticThemesData: {
                    ...state.staticThemesData,
                    [action.index]: action.value
                }
            };
        default:
            return state;
    }
};

export default staticStateReducer;
